export const GET_FORUMS = 'GET_FORUMS';
export const GET_FORUM_TOPICS = 'GET_FORUM_TOPICS';
export const ADD_FORUM_TOPIC = 'ADD_FORUM_TOPIC';
export const GET_TOPIC = 'GET_TOPIC';
export const SEARCH_FORUMS = 'SEARCH_FORUMS';